import React from 'react';

export function LoadingPage() {
  return (
    <div className="loader"></div>
  );
}
